import React from "react";

import { cx } from "~/tools/class-variance";

import styles from "./_table.module.css";
import { TableRow } from "./row";

export const TableHead = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>((props, ref) => (
	<TableRow ref={ref} role="rowgroup" {...props} className={cx(styles.head, props.className)} />
));
